import gql from 'graphql-tag'
import projectFragment from '../../fragments/project'

export default gql`mutation go($data: ProjectWriteoffInput!, $project_id: String!){
  upsertProjectWriteoff(data: $data){
    ${projectFragment}
  }
}`